import { useEffect } from "react";
import { useParams, useNavigate, Outlet } from "react-router-dom";
import TabsTwo from "src/components/atomic/Tabs/TabsTwo/TabsTwo";
import DynamicSubtabRenderer from "./DynamicSubtabRenderer";

interface DynamicSubtabsProps {
  activeParentTab: any;
  tabs: any;
  GetMixpanelContext: any;
  loanDetails: any;
  loanDetailsData: any;
  whiteLabelStyle: any;
  notify: any;
  token: any;
  useLocation: any;
  useNavigate: any;
}

const DynamicSubtabs = ({
  activeParentTab,
  tabs,
  GetMixpanelContext,
  loanDetails,
  loanDetailsData,
  whiteLabelStyle,
  notify,
  token,
  useLocation,
  useNavigate
}: DynamicSubtabsProps) => {
  const { loanID, "*": tail } = useParams();
  const navigate = useNavigate();

  const subTabExtractedPath = tail?.split("/")[1];
  const activeTab = tabs.find((t) => t.route === `/${tail?.split("/")[1]}`);

  useEffect(() => {
    if (!subTabExtractedPath && tabs.length > 0) {
      const firstTab = [...tabs].sort((a, b) => a.position - b.position)[0];
      const firstTabPath = firstTab.route;
      navigate(`${window.location.pathname}/${firstTabPath}`, {
        replace: true
      });
    }
  }, []);

  return (
    <div>
      <TabsTwo
        tabs={tabs}
        baseURL={`/loan-applications/details/${loanID}${activeParentTab.route}`}
        GetMixpanelContext={GetMixpanelContext}
      />

      <div>
        {activeTab && activeTab.rendererType === "ui_config_v1" && (
          <DynamicSubtabRenderer
            whiteLabelStyle={whiteLabelStyle}
            activeTab={activeTab}
            loanDetailsData={loanDetailsData}
            isLenderDashboard={true}
            notify={notify}
            token={token}
            useLocation={useLocation}
            useNavigate={useNavigate}
          />
        )}

        {activeTab && activeTab.rendererType === "default" && (
          <Outlet
            context={{
              whiteLabelStyle,
              hasMorePages: false,
              loanDetails: {
                ...loanDetails,
                createdAt: loanDetailsData.createdAt,
                updatedAt: loanDetailsData.updatedAt,
                cibilScore:
                  loanDetails?.bureauScores.find(
                    (b: any) => b.bureauName === "CIBIL"
                  )?.bureauScore ?? -1,
                cibilStatus:
                  loanDetails?.bureauScores.find(
                    (b: any) => b.bureauName === "CIBIL"
                  )?.bureauStatus ?? "",
                loanApplicationNum: loanDetailsData.loanApplicationNum,
                taskStatus: loanDetailsData?.workflowState,
                base: loanDetails.base,
                sourceEntityName: loanDetailsData.sourceEntityName,
                loanType: loanDetailsData?.loanType,
                userID: loanDetailsData.userID,
                status: loanDetailsData.status,
                reqLoanAmount: loanDetailsData.reqLoanAmount,
                processingFee: loanDetailsData.processingFee,
                industryMap: loanDetailsData.industryMap,
                utmSource: loanDetailsData?.utmSource ?? "",
                utmContent: loanDetailsData?.utmContent ?? "",
                utmMedium: loanDetailsData?.utmMedium ?? "",
                utmCampaign: loanDetailsData?.utmCampaign ?? "",
                campaignType: loanDetailsData?.campaignType ?? "",
                coApplicantDetails: loanDetailsData?.coApplicantDetails ?? [],
                directorDetails: loanDetailsData?.directorDetails ?? [],
                loanVariant: loanDetailsData?.loanVariant,
                constitution: loanDetailsData?.constitution,
                workflowInstanceID: loanDetailsData?.workflowInstanceID,
                offerMetaData: loanDetailsData?.loanDetails?.offerMetaData
              },
              tabDetails: tabs || [],
              location
            }}
          />
        )}
      </div>
    </div>
  );
};

export default DynamicSubtabs;
